import React, { Component } from 'react'
import { Header, Loader, Image, Label, Dimmer, Button, Segment } from 'semantic-ui-react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import moment from 'moment'
import _ from 'lodash'
import ImageCompressor from 'image-compressor.js'
import ImageUpload from '../../services/ImageUpload'
import firebase from '../../config/firebase'
import Loading from '../../components/common/loading'
import RestaurantActions from '../../reducers/restaurantReducer'
import PopularActions from '../../reducers/popularReducer'

class PopularItems extends Component {
  constructor() {
    super()

    this.state = {
      fetching: false,
      listData: null,
      uploading: {},
      compressing: {},
      publishing: false,
    }

    this.imageInput = {}
  }

  componentDidMount() {
    const { listData } = this.state
    const { restaurantLoaded, getRestaurants, popularListLoaded, getPopularList } = this.props

    if (listData === null) {
      this.setState({ fetching: true }, () => {
        this.getListData()
      })
    }

    if (!restaurantLoaded) {
      getRestaurants()
    }

    if (!popularListLoaded) {
      getPopularList()
    }
  }

  onImageChange(e, item) {
    const file = e.target.files[0]

    if (file) {
      this.compress(file, item)
    }
  }

  onImageUploaded(imageUrl, item) {
    const {
      location: {
        state: { listKey },
      },
    } = this.props
    const { listData, uploading } = this.state

    const updates = {}
    updates[`/popular_list/${listKey}/items/${item.itemKey}/image`] = imageUrl
    firebase
      .database()
      .ref()
      .update(updates)
      .then(err => {
        if (err) {
          alert(err)
        }

        this.setState({
          uploading: {
            ...uploading,
            [item.itemKey]: false,
          },
          listData: {
            ...listData,
            items: {
              ...listData.items,
              [item.itemKey]: {
                ...listData.items[item.itemKey],
                image: imageUrl,
              },
            },
          },
        })
      })
  }

  getListData() {
    const { location } = this.props
    const { listKey } = location.state

    firebase
      .database()
      .ref(`/popular_list/${listKey}`)
      .once('value', snapshot => {
        this.setState({ fetching: false, listData: snapshot.val() })
      })
  }

  compress = (file, item) => {
    const { compressing, uploading } = this.state
    const newCompressing = {
      ...compressing,
      [item.itemKey]: true,
    }

    this.setState({
      compressing: newCompressing,
    })

    const imageCompressor = new ImageCompressor()

    imageCompressor
      .compress(file, { quality: 0.6 })
      .then(result => {
        this.setState(
          {
            compressing: {
              ...compressing,
              [item.itemKey]: false,
            },
            uploading: {
              ...uploading,
              [item.itemKey]: true,
            },
          },
          () => {
            this.upload(result, item)
          }
        )
      })
      .catch(err => {
        alert('There is problem while while compressing file. Please try again.', err)
      })
  }

  upload = async (file, item) => {
    const {
      location: {
        state: { listKey },
      },
    } = this.props

    try {
      const imageUploader = new ImageUpload(file, 'image', {
        destination: `popular_items/${listKey}/${item.itemKey}`,
        type: `popu_image`,
        firebaseSavePath: `/popular_list/${listKey}/items/${item.itemKey}/compress_image`,
        manipulation: {
          width: 640,
          height: 0,
          size: 15000,
        },
      })

      const { originalUrl } = await imageUploader.upload()
      this.onImageUploaded(originalUrl, item)
    } catch (err) {
      alert('There is problem while uploading file. Please try again.', err)
    }
  }

  onEditPrice = async item => {
    const { listData } = this.state
    const {
      location: {
        state: { listKey },
      },
    } = this.props

    const pricePrompt = window.prompt('Input item price', item.price)
    try {
      if (pricePrompt) {
        this.setState(
          {
            listData: {
              ...listData,
              items: {
                ...listData.items,
                [item.itemKey]: {
                  ...listData.items[item.itemKey],
                  price: Number(pricePrompt),
                },
              },
            },
          },
          async () => {
            const {
              listData: { items },
            } = this.state
            const {
              [item.itemKey]: { price: newItemPrice },
            } = items

            const update = {}
            update[`/popular_list/${listKey}/items/${item.itemKey}/price`] = Number(newItemPrice)

            await firebase
              .database()
              .ref()
              .update(update)
          }
        )
      }
    } catch (err) {
      alert(err)
    }
  }

  // alertRemoveItem(item) {
  //   let conf = window.confirm(`Are you sure to remove ${item.name}?`)
  //   const listKey = this.props.location.state.listKey

  //   if (conf) {
  //     let updates = {}
  //     updates[`/popular_list/${listKey}/items/${item.itemKey}`] = null

  //     firebase.database().ref().update(updates).then((err) => {
  //       if (err) { alert(err) }

  //       let newListData = this.state.listData
  //       delete newListData.items[item.itemKey]

  //       this.setState({
  //         listData: newListData
  //       })
  //     })
  //   }
  // }

  toggleConfirmation(isPublished) {
    const status = isPublished ? 'draft' : 'publish'
    const conf = window.confirm(`Are you sure to ${status} this list?`)

    if (conf) {
      this.togglePublish(isPublished)
    }
  }

  togglePublish(isPublished) {
    const {
      popularList,
      location: {
        state: { listKey },
      },
    } = this.props
    const { listData } = this.state

    const updates = {}
    const newStatus = isPublished ? 'drafted' : 'published'

    if (isPublished) {
      updates[`popular_list/${listKey}/status`] = 'drafted'
    } else {
      _.mapKeys(popularList, (value, key) => {
        if (key === listKey) {
          updates[`popular_list/${listKey}/status`] = 'published'
        } else {
          updates[`popular_list/${key}/status`] = 'drafted'
        }
      })
    }

    this.setState({ publishing: true })

    firebase
      .database()
      .ref()
      .update(updates)
      .then(err => {
        if (err) {
          alert(err)
        }
        this.setState({
          publishing: false,
          listData: {
            ...listData,
            status: newStatus,
          },
        })
      })
  }

  renderItems() {
    const { listData } = this.state
    const listItems = listData.items

    return (
      <div>
        <div style={{ marginBottom: 14 }}>
          {`List items generated from `}
          <Label>{`${moment(parseInt(listData.order_query_start_at, 10)).format('DD-MMM-YYYY')}`}</Label>
          {` to `}
          <Label>{`${moment(parseInt(listData.order_query_end_at, 10)).format('DD-MMM-YYYY')}`}</Label>
        </div>
        {_.map(listItems, (item, index) => {
          return this.renderItemRow(item, index)
        })}
      </div>
    )
  }

  renderItemRow(item, index) {
    const { restaurants } = this.props
    const { listData, uploading, compressing } = this.state

    const loading = uploading[item.itemKey] || compressing[item.itemKey] || false

    const imageUrl =
      (listData.items[item.itemKey] && listData.items[item.itemKey].image) ||
      require('../../assets/images/placeholder250.png')

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          marginBottom: 14,
          border: '1px solid lightgray',
          borderRadius: 7,
          overflow: 'hidden',
        }}
        key={index}
      >
        <div style={{ marginRight: 14 }}>
          <div style={{ height: 200, width: 200 }}>
            <input
              hidden
              type="file"
              accept="image/*"
              onChange={e => this.onImageChange(e, item)}
              ref={input => {
                this.imageInput[item.itemKey] = input
              }}
            />
            <Image
              src={imageUrl}
              className="image-previewer-popular-item"
              onClick={() => this.imageInput[item.itemKey].click()}
              dimmer={
                <Dimmer active={loading}>
                  <Loader />
                </Dimmer>
              }
            />
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            paddingTop: 14,
            paddingBottom: 14,
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 style={{ margin: 0 }}>
              <span style={{ fontWeight: 'normal' }}>Item name:</span> {item.name}
            </h4>
            <br />
            <h4 style={{ margin: 0 }}>
              <span style={{ fontWeight: 'normal' }}>Restaurant name:</span>{' '}
              {restaurants[item.restaurantKey].name}
            </h4>
            <br />
            <h4 style={{ margin: 0 }}>
              <span style={{ fontWeight: 'normal' }}>Item Price:</span>
              <Label
                style={{ textAlign: 'center', cursor: 'pointer' }}
                onClick={() => this.onEditPrice(item)}
              >
                {` ${Number(item.price).toFixed(2)}$ `}
              </Label>
            </h4>
            <br />
            <Label style={{ marginLeft: 0 }}>
              Quantity
              <Label.Detail>{item.quantity}</Label.Detail>
            </Label>
          </div>
          <div>
            {
              // <Button color="red" onClick={() => this.alertRemoveItem(item)} size="tiny">
              //   Remove
              // </Button>
            }
          </div>
        </div>
      </div>
    )
  }

  renderPublished() {
    const { listData, publishing } = this.state

    if (listData !== null) {
      const isPublished = listData.status === 'published'

      return (
        <div style={{ position: 'absolute', right: 14, top: 14 }}>
          <Button
            onClick={() => this.toggleConfirmation(isPublished)}
            color={isPublished ? 'green' : 'red'}
            loading={publishing}
            disabled={publishing}
          >
            {listData.status === 'drafted' ? 'Drafted' : 'Published'}
          </Button>
        </div>
      )
    }
    return null
  }

  render() {
    const { fetching, listData } = this.state
    const { restaurantLoading, popularListLoading } = this.props

    return (
      <div>
        <Loading active={fetching || restaurantLoading || popularListLoading} />
        <Segment color="black" style={{ marginBottom: 14 }}>
          <div>
            <Header size="large"> List items </Header>
            {this.renderPublished()}
          </div>

          <div style={{ marginTop: 14 }}>{listData !== null && this.renderItems()}</div>
        </Segment>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  restaurants: state.restaurants.data,
  restaurantLoading: state.restaurants.loading,
  restaurantLoaded: state.restaurants.loaded,
  popularListLoaded: state.popular.listLoaded,
  popularListLoading: state.popular.listLoading,
  popularList: state.popular.popularList,
})

const mapDispatchToProps = dispatch => ({
  getRestaurants: () => dispatch(RestaurantActions.fetchRestaurantsRequest()),
  getPopularList: () => dispatch(PopularActions.getPopularList()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PopularItems))



// WEBPACK FOOTER //
// ./src/containers/advertisement/popular.js